import { render, staticRenderFns } from "./Delivery_StatusForm.vue?vue&type=template&id=4b39a9c4&scoped=true&"
import script from "./Delivery_StatusForm.vue?vue&type=script&lang=js&"
export * from "./Delivery_StatusForm.vue?vue&type=script&lang=js&"
import style0 from "./Delivery_StatusForm.vue?vue&type=style&index=0&id=4b39a9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39a9c4",
  null
  
)

export default component.exports